<script>
import Main from './main.vue';

export default Main.extend({
  methods: {
    getData() {
      return new Promise((res) => {
        // Seed data
        const output = [
          {
            name: 'SAE-J2405',
            data: [
              {
                x: Date.UTC(2019, 4, 12),
                y: 50,
                errors: {
                  serious: 30,
                  minor: 20,
                },
                qa: {
                  level: 80,
                  score: 70,
                },
                risk: 'high',
                words: 5500,
              },
              {
                x: Date.UTC(2019, 5, 12),
                y: 30,
                errors: {
                  serious: 10,
                  minor: 20,
                },
                qa: {
                  level: 90,
                  score: 95,
                },
                risk: 'medium',
                words: 6000,
              },
            ],
          },
          {
            name: 'TestZuzex',
            data: [
              {
                x: Date.UTC(2019, 4, 12),
                y: 70,
                errors: {
                  serious: 30,
                  minor: 20,
                },
                qa: {
                  level: 80,
                  score: 70,
                },
                risk: 'high',
                words: 5500,
              },
              {
                x: Date.UTC(2019, 5, 12),
                y: 60,
                errors: {
                  serious: 10,
                  minor: 20,
                },
                qa: {
                  level: 90,
                  score: 95,
                },
                risk: 'medium',
                words: 6000,
              },
            ],
          },
        ];
        res(output);
      });
    },
  },
});
</script>
